export enum InstructionInputType {
  GOVERNED_ACCOUNT,
  INPUT,
  TEXTAREA,
  SWITCH,
  SELECT,
  DISABLEABLE_INPUT,
}
